// extracted by mini-css-extract-plugin
export var closeButton = "PopupBanner-module--closeButton--59ad2";
export var popupContent = "PopupBanner-module--popupContent--ebdc7";
export var popupImage = "PopupBanner-module--popupImage--78cb4";
export var popupOverlay = "PopupBanner-module--popupOverlay--0382d";
export var visible = "PopupBanner-module--visible--95fb4";